/**
 * User provisioning — the closed set behind `users.provisioning_status`, and
 * the Auth0 sign-in methods an account can have.
 *
 * A staff member enters Nebari one of two ways: imported from FareHarbor by the
 * warehouse sync (no login yet), or invited by an operator. An invite always
 * pre-creates an Auth0 account that already carries the person's roles; their
 * first sign-in, with Google or a password, binds to it and activates the row.
 *
 * Kept zod-free like `crewPositions.ts`: each consumer builds its own enum from
 * these tuples.
 */

/** Lifecycle of a `users` row. `isActive` still governs deactivation separately. */
export const PROVISIONING_STATUSES = ['imported', 'invited', 'active'] as const;

export type ProvisioningStatus = (typeof PROVISIONING_STATUSES)[number];

/** Auth0 connection NAMES (what `/authorize?connection=` and `event.connection.name`
 *  carry), not strategies — `auth0` is the strategy behind the password connection. */
export const INVITE_CONNECTIONS = ['google-oauth2', 'Username-Password-Authentication'] as const;

export type InviteConnection = (typeof INVITE_CONNECTIONS)[number];

export const PROVISIONING_STATUS_LABELS: Record<ProvisioningStatus, string> = {
  imported: 'Imported',
  invited: 'Invited',
  active: 'Active',
};
